export const CLINIC = {
  doctor: "Dr. Prathusha K",
  title: "Endogynecologist",
  credentials: "M.B.B.S., M.S. (Obs & Gyn), Fellowship in Endogynecology (KNRUHS)",
  experience: "6+ years of clinical experience in women's health",
  photo: "/images/dr-prathusha.jpg",
  address: "Care Hospitals, Road No. 1, Banjara Hills, Hyderabad, Telangana 500034",
  phone: "+91 77022 21744",
  phoneHref: "tel:+917702221744",
  hours: "Mon – Sat, 5:00 PM – 7:00 PM",
  onlineHours: "Daily, 9:00 – 11:00 AM & 7:00 – 9:00 PM",
  mapEmbed:
    "https://www.google.com/maps?q=Care+Hospitals+Road+No+1+Banjara+Hills+Hyderabad&output=embed",
  mapsLink: "https://www.google.com/maps?q=Care+Hospitals+Road+No+1+Banjara+Hills+Hyderabad",
};

export const CLINIC2 = {
  name: "Trust Health Care Multi Speciality Clinics",
  address:
    "Srinagar Colony Main Rd, Sri Nagar Colony, Banjara Hills, Hyderabad, Telangana 500073",
  hours: "Mon – Sat, 11:00 AM – 1:00 PM",
  mapEmbed:
    "https://www.google.com/maps?q=Trust+Health+Care+Multi+Speciality+Clinics,+Srinagar+Colony+Main+Rd,+Sri+Nagar+Colony,+Banjara+Hills,+Hyderabad+500073&output=embed",
  mapsLink: "https://maps.app.goo.gl/f1T5N8Litak1YPXf8",
};

export const SERVICES = [
  {
    id: "anc",
    name: "Antenatal Care (ANC)",
    tagline: "Caring for you and your baby, every step of the way",
    image:
      "https://images.unsplash.com/photo-1538678867871-8a43e7487746?auto=format&fit=crop&w=900&q=60",
    description:
      "Pregnancy is one of life's most beautiful journeys — and every journey deserves a trusted companion. Our antenatal care programme is designed to support you from the moment you discover you're expecting, right through to delivery. With regular check-ups, careful monitoring, and gentle guidance, we make sure both you and your baby are thriving at every stage.",
    bullets: [
      "Routine antenatal check-ups & trimester-wise care plans",
      "High-risk pregnancy monitoring and management",
      "Growth scan coordination & foetal well-being assessment",
      "Nutrition, supplements & lifestyle guidance during pregnancy",
      "Birth preparedness and delivery planning",
    ],
  },
  {
    id: "endogyn",
    name: "Endogynecological Procedures",
    tagline: "Advanced, minimally invasive women's care",
    image:
      "https://images.pexels.com/photos/6129444/pexels-photo-6129444.jpeg?auto=compress&cs=tinysrgb&w=900",
    description:
      "When a procedure is needed, you deserve precision, safety and the shortest possible recovery. As a fellowship-trained Endogynecologist, Dr. Prathusha specialises in minimally invasive (keyhole) gynaecological procedures that mean smaller incisions, less pain, and a faster return to your everyday life.",
    bullets: [
      "Diagnostic & operative hysteroscopy",
      "Diagnostic & operative laparoscopy",
      "Removal of fibroids (myomectomy) and polyps (polypectomy)",
      "Ovarian cystectomy & management of ovarian cysts",
      "Evaluation & surgical management of endometriosis",
    ],
    preOpNote:
      "Please note: A standard pre-operative consultation is required before scheduling any endogynecological procedure. During this visit, Dr. Prathusha will review your reports, explain the procedure, discuss anaesthesia fitness, and answer all your questions — so that you walk in fully informed and confident.",
  },
  {
    id: "prenatal",
    name: "Prenatal Counselling",
    tagline: "Plan your parenthood journey with confidence",
    image:
      "https://images.pexels.com/photos/7578797/pexels-photo-7578797.jpeg?auto=compress&cs=tinysrgb&w=900",
    description:
      "Whether you're planning your first pregnancy or preparing for the next, the right guidance early on makes all the difference. Our prenatal counselling sessions give you a safe, unhurried space to ask questions, understand your health, and prepare your body and mind for a healthy pregnancy.",
    bullets: [
      "Preconception health evaluation & planning",
      "Genetic counselling coordination & screening guidance",
      "Medication and chronic-condition review before pregnancy",
      "Birth-plan counselling and emotional preparedness",
      "Guidance for couples after previous pregnancy loss",
    ],
  },
  {
    id: "pcos",
    name: "PCOS Management",
    tagline: "A holistic path to hormonal balance",
    image:
      "https://images.pexels.com/photos/7578810/pexels-photo-7578810.jpeg?auto=compress&cs=tinysrgb&w=900",
    description:
      "PCOS affects every woman differently — which is why we never believe in one-size-fits-all treatment. From irregular cycles and acne to weight changes and fertility concerns, we look at the complete picture of your health and craft a plan that works for your body and your life.",
    holistic:
      "Our holistic approach: We combine evidence-based medical treatment with personalised nutrition, lifestyle coaching, stress management and long-term metabolic monitoring. Rather than only treating symptoms, we partner with you to address the root hormonal imbalance — gently, sustainably, and at your pace.",
    bullets: [
      "Comprehensive hormonal evaluation & cycle regulation",
      "Personalised nutrition & weight-management plans",
      "Management of acne, hair fall & excess hair growth",
      "Fertility-focused PCOS care for women planning pregnancy",
      "Long-term screening for diabetes & metabolic health",
    ],
  },
  {
    id: "fertility",
    name: "Fertility-Related Treatment",
    tagline: "Compassionate care for your path to parenthood",
    image:
      "https://images.unsplash.com/photo-1531983412531-1f49a365ffed?auto=format&fit=crop&w=900&q=60",
    description:
      "The journey to parenthood isn't always straightforward — and you should never have to walk it alone. We offer thorough, judgement-free fertility evaluation and treatment in a private, supportive environment, always keeping your comfort, dignity and hopes at the centre of care.",
    holistic:
      "Our holistic approach: Fertility is influenced by far more than test reports. Alongside medical evaluation and treatment, we focus on nutrition, emotional well-being, cycle awareness and partner health — building a complete, personalised roadmap. Every plan is explained transparently, so you always know your options and remain in control of every decision.",
    bullets: [
      "Complete fertility evaluation for couples",
      "Ovulation induction & follicular monitoring",
      "IUI guidance and procedure coordination",
      "Management of recurrent pregnancy loss",
      "Fertility preservation advice & counselling",
    ],
  },
];

export const FAQS = [
  {
    q: "Do I need to register before booking an appointment?",
    a: "Yes. To protect your privacy and keep your medical records secure, only registered patients can book appointments. Registration takes under two minutes — you'll need your email ID and phone number, and a one-time password (OTP) will be sent to verify your account.",
  },
  {
    q: "What are the clinic timings?",
    a: "Dr. Prathusha consults at two locations, Monday to Saturday: Trust Health Care Multi Speciality Clinics, Srinagar Colony Main Rd, Banjara Hills from 11:00 AM to 1:00 PM, and Care Hospitals, Road No. 1, Banjara Hills from 5:00 PM to 7:00 PM. Online consultations are available daily from 9:00–11:00 AM and 7:00–9:00 PM.",
  },
  {
    q: "How much does an online consultation cost?",
    a: "Online consultations are priced at ₹100 for a 15-minute slot. In-clinic consultation fees vary by service and are shown on your booking confirmation screen.",
  },
  {
    q: "How do I pay for my appointment?",
    a: "Once your appointment is confirmed by the clinic team, you can pay securely online from your patient dashboard, or choose to pay by cash at the clinic during your visit. Online consultations are payable online.",
  },
  {
    q: "Is my medical information safe?",
    a: "Absolutely. Your records are protected with role-based access — only you and Dr. Prathusha can view your documents and history. All data is transmitted over encrypted HTTPS connections, in line with India's DPDP Act 2023 and healthcare privacy best practices.",
  },
  {
    q: "What should I bring to my first appointment?",
    a: "Please bring any previous medical records, scan or lab reports, a list of current medications, and your filled patient intake form (downloadable from this page). Arriving 10 minutes early helps us serve you better.",
  },
  {
    q: "Can I cancel or reschedule my appointment?",
    a: "Yes — unpaid appointments can be cancelled from your patient dashboard. To reschedule, simply cancel and book a new slot, or call us at +91 77022 21744 and we'll assist you.",
  },
  {
    q: "Are online consultations legally valid?",
    a: "Yes. Our online consultations follow the Telemedicine Practice Guidelines 2020 issued by the Board of Governors (MCI/NMC). Please note online consultations are not suitable for emergencies — in an emergency, please visit the nearest hospital immediately.",
  },
];

export const PRE_APPOINTMENT = [
  "Arrive 10 minutes before your scheduled slot for in-clinic visits.",
  "Carry previous prescriptions, scan reports, and lab results (originals or digital copies).",
  "Note down your symptoms, their duration, and any questions beforehand.",
  "For online consultations, join from a quiet, private space with stable internet.",
  "If you are coming for a pre-operative consultation, please come fasting only if specifically advised.",
  "Download, print and fill the Patient Intake Form below to save time at the clinic.",
];

// Defaults for admin-editable site content (overridden from the backend CMS)
export const DEFAULT_SITE_CONTENT = {
  hero: {
    badge: "Endogynecology · Banjara Hills, Hyderabad",
    title: "Gentle, expert care for every chapter of a woman's life",
    intro:
      "Welcome — I'm Dr. Prathusha K, an Endogynecologist devoted to women's health in Hyderabad. Whether you're planning a pregnancy, navigating PCOS, exploring fertility options, or need advanced gynaecological treatments, you'll always find a listening ear, clear answers, and treatment designed around you — never the other way around.",
  },
  about: {
    p1: "Every woman's health story is unique — and it deserves to be heard with patience, understood with expertise, and cared for with warmth. That belief is at the heart of everything we do at this practice.",
    p2: "Dr. Prathusha Kolachana is a fellowship-trained Endogynecologist and Consultant at CARE Hospitals, Banjara Hills, with over six years of clinical experience in Obstetrics & Gynaecology. She trained and worked alongside Padma Shri awardee Dr. Manjula Anagani, one of India's foremost laparoscopic and robotic gynaecological surgeons — an experience that shaped her precision-first, patient-always approach.",
    p3: "She independently performs advanced laparoscopic (keyhole) surgeries — hysterectomies, myomectomies, ovarian cystectomies and emergency procedures — and has first-assistance experience in robotic gynaecological surgery. From high-volume labour rooms conducting over a thousand deliveries a month to complex minimally invasive procedures, her care is grounded in evidence-based practice and genuine empathy. She consults in English, Telugu, Hindi and Kannada.",
  },
  clinic: {
    address: CLINIC.address,
    phone: CLINIC.phone,
    hours: CLINIC.hours,
    onlineHours: CLINIC.onlineHours,
  },
  services: Object.fromEntries(
    SERVICES.map((s) => [s.id, { tagline: s.tagline, description: s.description }])
  ),
};
